export default __webpack_public_path__ + "static/media/HatchBack.85eee27b.svg";